import { LModalContentsWidthType, ModalType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { MenuComponent } from './menu.component';
export interface MenuPayload {}
export function myBookingMenuPayloadParts(): ModalBlockParts {
  return {
    id: 'MenuComponent',
    block: MenuComponent,
    closeBackEnable: false,
    type: ModalType.TYPE4,
    modalWidth: LModalContentsWidthType.NONE,
    payload: {} as MenuPayload,
  };
}
